/*
Author: Chathuraka Mallawa Arachchi
Date: 25/09/2024
Copyright © 2024 Infix!. All rights reserved.
*/

import {DatePicker} from "@/components/Atoms";
import InputLabel from "@/components/Atoms/InputLabel";
import {useResponseId,useUrlType} from "@/components/hooks";
import {RootState} from "@/reducers/store";
import {useValidate} from "@/state/survey/formSlice";
import {BasicAnswerSave,useUpdateAnswersSubmit} from "@/state/survey/saveAnswerSlice";
import {Utility} from "@/utils";
import Validate from "@/utils/Validate/validate";
import {ReactNode,useCallback,useEffect,useRef,useState} from "react";
import {useSelector} from "react-redux";
import poaAnswerDetails from "../../SurveyModel/poaQuestions/poaAnswerDetails";
import {IComponentMetaData} from "../../SurveyModel/types/commonTypes";
import {INode} from "../../SurveyModel/types/nodeTypes";

interface IDatePickerNode {
    node: INode
    children: ReactNode
    name: string
    disabled: boolean
    metaData?: IComponentMetaData
    repeatedElement?:boolean
    onBlur?:()=> void
    type?:string
    propClasses: string
    isPatient: boolean
}

const DatePickerNode:React.FC<IDatePickerNode>  = (props:IDatePickerNode) => {
    //repeatedElement - only available with complex question types with repeated nodes.
    const {node, children, name,  repeatedElement, onBlur} = props;
    const form = useSelector((state:RootState) => state.form);
    const [questionName, setQuestionName] = useState('') 
    const validateInputField = useValidate();
    const updateAnswersDispatch = useUpdateAnswersSubmit();
    const {answerResponseId} = useResponseId();
    const hasExecuted = useRef(false);
    const { state = {} } = form[node.name];
    const [inputValue, setInputValue ] = useState(form[node.name].value);
    const {isPatient} = useUrlType();


    useEffect(()=>{
        if(form[node.name].value !== inputValue){
            setInputValue(form[node.name].value )
        }
    }, [form, inputValue]);
   
   // Wrap handleChange with useCallback
   const handleChange = useCallback(
        (value: string | null) => {
            const dateValue:  string | null = value
            // if(value){
            //     dateValue = moment(value, "DD-MM-YYYY").format("YYYY-MM-DD")
            // }
            validateInputField(node.name, dateValue, true);
            if(node.validationDependants) {
                node.validationDependants.forEach((element : string)=> {
                validateInputField(element, form[element].value, true);
            });
            }
        },
        [validateInputField,form, node]
    );
    
    const handleOnBlur = () => {
        if(!isPatient && answerResponseId && !repeatedElement) {
            const answers: BasicAnswerSave[] = poaAnswerDetails.generateQuestionAnswerSubmitFormat(form,node )
            updateAnswersDispatch(answers, answerResponseId);
        } 
        if(repeatedElement && onBlur) 
            onBlur()
    }


    useEffect(()=>{
        if(!isPatient && name && form[node.name] && questionName != name && !hasExecuted.current){ //poa only
            validateInputField(name, form[node.name].value, true);
            setQuestionName(name)
            hasExecuted.current = true;
        }
    }, [form, questionName, node, isPatient, name,validateInputField ])
    
    return (
        <div className={ `date-picker-wrap 
        ${Utility.getClassForWidthPx(node)}  ${Utility.getClassForWidth(node)} 
         ${node.name}
        question-bottom-space-1
        ${!repeatedElement ? `user-input ${!Utility.getClassForWidthPx(node) && !Utility.getClassForWidth(node) ? 'flex-1' : ''} ${!isPatient ? 'poa-input': '' } 
        input-border-top` : ''}`}>
           <InputLabel label={node.title} labelClasses="input-label"></InputLabel> 
        {node.subTitle  ? <InputLabel type="subTitle" label={node.subTitle } labelClasses="input-label"></InputLabel> : ''}
            {/* <SingleChoice propClasses={'single-chocie-choices flex'} value={form[node.name].value} options={node.options} name={node.name} onChange={handleChange}/> */}
            <div>
        <DatePicker
         isPatient={isPatient}
         isInValid = {Validate.isInvalid(state)} 
         onBlur={handleOnBlur}
         initialDate ={form[node.name]?.value  ? form[node.name]?.value as string : null }
         onChange={handleChange}
         name={node.name} 
         form={form}
         showErrors={true}
         /> 
        </div>
            <div>{children}</div>
        </div>
    )
}

export default DatePickerNode;